<template>
  <div class="animate_animated animate__slideInRight">
    <div class="fixed inset-x-0 top-0 z-20">
      <div class=" bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80">
         <div class="h-1 bg-gradient-to-r from-amber-500 to-amber-200"></div>
        <div class="flex items-center px-4 py-4">
          <div class="w-1/2">
            <div class="flex items-center w-full">
              <a @click="$route.query.match ? $router.go(-1) : $router.push('/')"><img src="@/assets/back-arrow.svg"
                  alt=""></a>
              <span class="text-base text-content font-medium ml-4">{{ $route.query.match ? 'Matches' :
                  'Enquiries'
              }}</span>
            </div>
          </div>
          <div class="w-1/2">
            <div class="flex items-center justify-end">
              <a @click="$router.push('searchenquiry')" class="text-main bg-slate-100 p-2.5 rounded-xl"><Filter class="size-5"/></a>
            </div>
          </div>
        </div>
        <div class="flex px-3 pb-3">
          <div class="flex items-strech w-full gap-2">
            <div class="relative w-full">
              <input type="text" @input="e => bsTerm = e.target.value" :value="bsTerm" name="" id=""
                placeholder="Search Enquiry"
                class="border border-inputBorder round-md p-3 w-full z-auto focus:outline-none rounded-xl">
              <button type="button" class="absolute right-0 top-0 m-3" v-if="bsTerm" @click="resetBs">
                <img src="@/assets/close-icon.svg" alt="" class="transform rotate-45"></button>
            </div>

            <div class="bg-primary px-4 flex items-center rounded-xl">
              <button type="button" :disabled="!bsTerm" @click="performBs">
                <img src="@/assets/search-icon-white.svg" alt="" class=""></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-16 mt-16 ">
      <div class="bg-gray-50 min-h-screen px-4">
        <span class="result-Text px-1 pt-4 text-sm text-main text-opacity-50 block mb-3">Showing {{ pageStart }} - {{
          pageEnd
        }} of {{ total }}</span>
        <LeadsListLayout :activeStatus="activeStatus" :selectStatus="goTo" />
         <div class=" bg-white pt-3 my-3 rounded-xl" v-for="(el, key) in enquiryList" :key="key">
        <router-link :to="{ name: 'DetailsEnquiry', params: { uuid: el.uuid } }">
          <div class="px-4">
            <div class="flex items-center justify-between gap-2">
              <div class="">
                <span class="text-content text-sm font-medium">&#8377; {{ $asINR(priceinLacs(el.budget)  ) }} {{ el.city }}</span>
              </div>
              <div class=" ">
                <span class="inline-flex items-center gap-1 px-2 py-1 rounded font-medium text-xs cursor-pointer transition bg-slate-100 text-main hover:bg-slate-200">{{ el.status }}</span>
              </div>
            </div>
            <div class="flex items-center mt-1 mb-1">
              <span
                class="text-main text-sm">{{ el.name }}</span>
            </div>
            <div class="grid grid-cols-2 gap-1">
									<div class="" v-if="el.preferred_project">
										<span class="block text-xs text-slate-500 ">Preferred Project:</span>
										<span class="block text-sm text-slate-800 ">{{ el.preferred_project }}</span>
									</div>
                  <div class="" v-if="el.preferred_property">
										<span class="block text-xs text-slate-500 ">Preferred Property:</span>
										<span class="block text-sm text-slate-800 ">{{ el.preferred_property }}</span>
									</div>
                  <div class="" >
										<span class="block text-xs text-slate-500 ">Assigned:</span>
										<span class="block text-sm text-slate-800 ">{{ el.user || '-'}}</span>
									</div>
                  <div class="" >
										<span class="block text-xs text-slate-500 ">Possession:</span>
										<span class="block text-sm text-slate-800 ">{{ el.possession_by || '-'}}</span>
									</div>
                  <div class="" >
										<span class="block text-xs text-slate-500 ">Source:</span>
										<span class="block text-sm text-slate-800 ">{{ el.display_source || '-'}}</span>
									</div>
                   <div class="" >
										<span class="block text-xs text-slate-500 ">NCD:</span>
										<span class="block text-xs text-slate-800 ">{{ el.formatted_ncd || '-'}}</span>
									</div>
                  <div class="" v-if="deadStatusIds.includes('' + el.status_id)">
										<span class="block text-xs text-slate-500 ">Dead Reason:</span>
										<span class="block text-sm text-slate-800 ">{{ el.dead_reason }}</span>
									</div>
								</div>
          </div>
        </router-link>
        <div class="flex items-center px-4 border-b py-2 bg-gradient-to-b from-white to-gray-50 rounded-xl ">
          <div class="w-1/2">
            <div class="flex items-center w-full" v-if="el.property_matches > 0" @click="filterMatchesProperties(el)">
              <span
                class="min-w-6 h-6 bg-success rounded-lg text-white font-semibold text-xs mr-1 flex items-center justify-center px-3">{{ el.property_matches }}</span>
              <span class="text-xs text-content font-medium">Matches</span>
            </div>
          </div>
          <div class="w-1/2">
            <div class="flex items-center justify-end gap-2">
              <router-link :to="{ name: 'History', params: { uuid: el.uuid } }" class="text-main bg-slate-100 p-2.5 rounded-xl"><img
                  src="@/assets/history.svg" alt=""></router-link>
              <a :href="el.mobile && `https://wa.me/${waNum(el.mobile)}`" v-if="el.mobile" class="text-main bg-slate-100 p-2.5 rounded-xl"><img
                  src="@/assets/whatsapp.svg" alt=""></a>
              <a :href="el.email && `mailto: ${el.email}`" v-if="$route.query.match && el.email" class="text-main bg-slate-100 p-2.5 rounded-xl"><img
                  src="@/assets/email-icon.svg" alt=""></a>
              <a :href="el.mobile && `tel:${el.mobile}`" v-if="el.mobile" class="text-main bg-slate-100 p-2.5 rounded-xl"><img
                  src="@/assets/phone-icon.svg" alt=""></a>
            </div>
          </div>
        </div>
      </div>
      </div>
     
      <!-- Add Button -->
      <router-link :to="{ name: 'NewEnquiry' }" v-if="!$route.query.match"
        class="fixed bottom-6 right-6 z-50 overflow-hidden group rounded-xl px-4 py-4 flex items-center gap-2 text-white shadow-xl ring-1 ring-white/10 bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-500 hover:from-emerald-500 hover:to-teal-500 transition-all duration-300 ease-out hover:scale-105 active:scale-95 shine">
        <img src="@/assets/plus-icon.svg" alt="">
      </router-link>
      <div class="pagination-holder">
        <Pagination v-if="totalPages > 1" v-model="pageNo" :total-pages="totalPages" @update:modelValue="goToPage" />
      </div>
    </div>
  </div>
</template>
<script>
import LeadsListLayout from '@/components/Common/ListLayout.vue';
import qs from 'qs';
import { paramsFromQuery, waFormatter, prepareEnquirySearchParams, numDifferentiation } from '@/assets/scripts/utility.js';
import Filter from '@/components/icons/Filter.vue';
export default {
  components: {
    LeadsListLayout,
    Filter
  },
  data() {
    return {
      bsTerm: this.$route.query.bs,
      total: 0,
      perPage: 0,
      enquiryList: [],
      advSearchParams: [],
      activeStatus: 'all'
    }
  },
  watch: {
    $route(to, from) {
      this.selectStatus();
    }
  },
  created() {
    this.$store.dispatch('setnewEnquiryData', {});
    this.selectStatus();
  },
  methods: {
    goTo(status) {
      let newQ = { ...this.$route.query, status_id: status }
      if (status === 'all') {
        delete newQ['status_id'];
      }
      delete newQ['sortDir'];
      delete newQ['sortKey'];
      delete newQ['pageNo'];
      this.$router.replace({ query: newQ });
    },
    selectStatus() {
      let status = this.$route.query.status_id || 'all';
      let sendable;
      if (status != 'all') {
        this.activeStatus = `${status}`
        sendable = status;
      } else {
        this.activeStatus = 'all'
      }
      this.loadEnquiries(sendable);
    },
    priceinLacs(value) {
      return numDifferentiation(value)
    },
    waNum(el) {
      return waFormatter(el);
    },
    filterMatchesProperties(enquiry) {
      let apiParams = {}
      apiParams['lead_id'] = enquiry.id
      apiParams['match'] = true
      apiParams["as"] = true
      this.$router.replace({ name: 'Properties', query: apiParams });
    },
    loadEnquiries(status) {
      let queryP = {}
      if (Object.keys(this.advSParams).length > 0) {
        queryP["as"] = true
        let searchParams = prepareEnquirySearchParams(this.advSParams);
        for (let key in searchParams) {
          queryP[key] = searchParams[key];
        }
        this.advSearchParams = queryP
      }
      if (this.advSearchParams.length > 0) {
        paramsFromQuery(queryP, this.advSearchParams, status);
      }
      else {
        paramsFromQuery(queryP, this.$route.query, status);
      }

      if (queryP.lead_statuses) {
        if(queryP.lead_statuses.length > 0) {
          queryP.ss_id = null
        }
      }
      let data = this.$axios.get('/mobile_crm/leads', {
        params: queryP,
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
      })
        .then(res => {
          this.enquiryList = res.data.leads;
          this.perPage = res.data.per_page;
          this.total = res.data.count;
        })
        .catch(err => console.log(err));
    },
    goToPage(pageNo) {
      let newQ = { ...this.$route.query, pageNo };
      this.$router.replace({ query: newQ });
    },
    resetBs() {
      let rQ = this.$route.query
      this.bsTerm = ''
      if (rQ.bs) {
        delete rQ.bs;
        let reset = {}
        for (let key in rQ) {
          reset[key] = rQ[key];
        }
        reset['reset'] = reset.reset ? (reset.reset == 0 ? 1 : 0) : 1
        this.$router.push({ query: reset });
      }
    },
    performBs() {
      if (this.bsTerm) {
        let newQ = { ...this.$route.query, bs: this.bsTerm }
        delete newQ.pageNo
        this.$router.replace({ query: newQ })
      }
    }
  },
  computed: {
    advSParams() {
      return this.$store.getters.advSParams;
    },
    statusList() {
      return this.$store.getters.statusesMaster;
    },
    deadStatusIds() {
      return this.$store.getters.deadStatusIds;
    },
    totalPages() {
      if (this.total === 0 || this.perPage === 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.perPage);
      }
    },
    pageNo: {
      get() {
        let pageNo = this.$route.query.pageNo || 1
        return parseInt(pageNo);
      },
      set() {
        true;
      }
    },
    pageStart() {
      if (this.total === 0) {
        return 0;
      }
      return (Math.max(0, (this.pageNo - 1) * this.perPage + 1))
    },
    pageEnd() {
      if (this.total === 0) {
        return 0;
      }
      return (Math.min(this.total, this.pageNo * this.perPage))
    },
  }
}
</script>
<style scoped>
.enquiry-label {
  @apply border-r border-divider pr-3 mr-3 inline-flex mb-2;
}

.enquiry-label:first-child {
  @apply pl-0;
}

.enquiry-label:last-child {
  @apply border-none;
}
</style>